import type { OrderMessageRow } from 'src/api/db/apiOrderMessage'

export const TEAM_PING_TOOL_RESULT = 'team_ping'

export const createTeamPingMessageContent = () =>
  JSON.stringify({ tool_result: TEAM_PING_TOOL_RESULT })

const parseOrderMessageContent = (content: string) => {
  try {
    return JSON.parse(content) as Record<string, unknown>
  } catch {
    return null
  }
}

export const isTeamPingMessage = (
  message: Pick<OrderMessageRow, 'role' | 'content'>
) => {
  if (message.role !== 'system') return false

  const normalized = (message.content ?? '')
    .trim()
    .replace(/&quot;/g, '"')
    .replace(/&#34;/g, '"')

  if (!normalized.includes(TEAM_PING_TOOL_RESULT)) return false

  const parsed = parseOrderMessageContent(normalized)
  return parsed?.tool_result === TEAM_PING_TOOL_RESULT
}
